export default "/images/user-ic.svg?3b76ab3ce14a0534469c426bda62861e";